/* istanbul ignore file */ import { logClientError } from '@shared/utils/appUtils';
import { getWindow } from '@shared/services/window';
const KNOWN_HYDRATION_INTERRUPTION_ERRORS = [
    'Root did not complete',
    'Minified React error #345'
];
/**
 * We are avoiding error propagation. This error happens when the client is not fully hydrated, yet user attempts to interact with it.
 * The client is still recoverable due to server-side navigation, although we will re-attempt to hydrate and trigger the client-side for full functionality.
 */ export function handleInterruptedHydration(errorMsg) {
    const isKnownIssue = KNOWN_HYDRATION_INTERRUPTION_ERRORS.some((issue)=>{
        var _errorMsg_includes;
        return errorMsg === null || errorMsg === void 0 ? void 0 : (_errorMsg_includes = errorMsg.includes) === null || _errorMsg_includes === void 0 ? void 0 : _errorMsg_includes.call(errorMsg, issue);
    });
    if (isKnownIssue) {
        var _getWindow_HYDRATE, _getWindow;
        (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow_HYDRATE = _getWindow.HYDRATE) === null || _getWindow_HYDRATE === void 0 ? void 0 : _getWindow_HYDRATE.call(_getWindow);
    }
    return isKnownIssue;
}
export function handleRecoverableHydrationError(error, errorInfo, env) {
    if (env !== 'prod') {
        console.warn('DEBUG: HYDRATION ERROR BELOW!');
        console.warn('this error should be visible in non-production environments as awareness when recovrable hydration issues occur and should always be fixed!');
        console.warn('======================== DEBUG: HYDRATION ERROR START ================================');
        console.error(error);
        console.warn('DEBUG: HYDRATION ERROR componentStack');
        console.warn(errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.componentStack);
        console.warn('======================== DEBUG: HYDRATION ERROR END ================================');
        throw error;
    }
    logClientError(error, `client side error: React recoverable hydration error ${error}`, '', true);
}
